<template>
  <div class="w-full flex flex-col items-center">
    <div class="w-full flex flex-col max-w-xl relative p-4">
      <button class="nxp-vacancy-detail-close-btn" type="button" @click="$router.back()">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <rect width="24" height="24" transform="translate(0.392578)" fill="white" fill-opacity="0.01" />
          <path
            d="M12.3926 10.5861L7.09962 5.29308C6.91102 5.11092 6.65841 5.01013 6.39622 5.01241C6.13402 5.01469 5.88321 5.11985 5.6978 5.30526C5.51239 5.49067 5.40722 5.74148 5.40495 6.00368C5.40267 6.26588 5.50346 6.51848 5.68562 6.70708L10.9786 12.0001L5.68562 17.2931C5.50346 17.4817 5.40267 17.7343 5.40495 17.9965C5.40722 18.2587 5.51239 18.5095 5.6978 18.6949C5.88321 18.8803 6.13402 18.9855 6.39622 18.9878C6.65841 18.99 6.91102 18.8892 7.09962 18.7071L12.3926 13.4141L17.6856 18.7071C17.8742 18.8892 18.1268 18.99 18.389 18.9878C18.6512 18.9855 18.902 18.8803 19.0874 18.6949C19.2728 18.5095 19.378 18.2587 19.3803 17.9965C19.3826 17.7343 19.2818 17.4817 19.0996 17.2931L13.8066 12.0001L19.0996 6.70708C19.1951 6.61483 19.2713 6.50449 19.3237 6.38249C19.3761 6.26048 19.4037 6.12926 19.4049 5.99648C19.406 5.8637 19.3807 5.73202 19.3304 5.60913C19.2802 5.48623 19.2059 5.37458 19.112 5.28069C19.0181 5.18679 18.9065 5.11254 18.7836 5.06226C18.6607 5.01198 18.529 4.98668 18.3962 4.98783C18.2634 4.98898 18.1322 5.01657 18.0102 5.06898C17.8882 5.12139 17.7779 5.19757 17.6856 5.29308L12.3926 10.5861Z"
            fill="#42526E" />
        </svg>
      </button>

      <h1 class="mt-10 mb-4">{{ title }}</h1>

      <div class="w-full flex flex-col gap-1 nxp-vacancy-card-location">
        <div class="w-full flex flex-col gap-1">
          <div v-if="location" class="w-full flex flex-row gap-2 items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
              <g clip-path="url(#clip0_1984_19482)">
                <path
                  d="M6.99997 13.2629C8.47557 11.9718 9.62471 10.7135 10.4474 9.48788C11.2701 8.2623 11.6814 7.1816 11.6814 6.24577C11.6814 4.88628 11.2396 3.75527 10.3559 2.85273C9.47216 1.95018 8.35353 1.49891 6.99997 1.49891C5.64642 1.49891 4.52779 1.95018 3.64408 2.85273C2.76037 3.75527 2.31852 4.88628 2.31852 6.24577C2.31852 7.1816 2.72986 8.2623 3.55255 9.48788C4.37524 10.7135 5.52438 11.9718 6.99997 13.2629ZM6.99997 14.2318C6.86206 14.2318 6.73383 14.2091 6.61527 14.1635C6.49658 14.1179 6.37622 14.0469 6.25418 13.9507C5.88212 13.633 5.41595 13.1996 4.85566 12.6503C4.29551 12.1011 3.75 11.4844 3.21913 10.8001C2.68813 10.1158 2.23757 9.38274 1.86744 8.60082C1.49732 7.81877 1.31226 7.03376 1.31226 6.24577C1.31226 4.66594 1.84164 3.31335 2.90041 2.18801C3.95931 1.06267 5.32583 0.5 6.99997 0.5C8.66121 0.5 10.0245 1.06267 11.0899 2.18801C12.1551 3.31335 12.6877 4.66594 12.6877 6.24577C12.6877 7.03376 12.4994 7.82071 12.1228 8.60663C11.7463 9.39267 11.297 10.1291 10.775 10.8158C10.2529 11.5025 9.71179 12.116 9.15164 12.6563C8.59149 13.1967 8.12531 13.6256 7.75313 13.9431C7.63289 14.0394 7.51233 14.1115 7.39145 14.1597C7.2707 14.2078 7.14021 14.2318 6.99997 14.2318ZM7.00133 7.43955C7.34772 7.43955 7.64147 7.31854 7.88259 7.07652C8.12383 6.8345 8.24445 6.5403 8.24445 6.19391C8.24445 5.84752 8.12344 5.55371 7.88142 5.31246C7.6394 5.07135 7.34514 4.95079 6.99862 4.95079C6.65223 4.95079 6.35848 5.0718 6.11736 5.31382C5.87612 5.55584 5.7555 5.85011 5.7555 6.19662C5.7555 6.54301 5.87651 6.83676 6.11853 7.07788C6.36055 7.31899 6.65481 7.43955 7.00133 7.43955Z"
                  fill="#696969" />
              </g>
              <defs>
                <clipPath id="clip0_1984_19482">
                  <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                </clipPath>
              </defs>
            </svg>
            <p>{{ location }}</p>
          </div>
          <p v-if="remuneration"><b> {{ formattedRemuneration }}</b></p>
        </div>
        <p v-if="vacancy_company_name">{{ vacancy_company_name }}</p>
      </div>

      <div class="w-full flex flex-row gap-4 my-8">
        <div v-if="vacancy.show_regime" class="nxp-featured-tag">
          {{ vacancy.regime.description }}
        </div>
        <div v-if="vacancy.remote" class="nxp-featured-tag">{{ vacancy.remote ? 'Remoto' : 'Presencial' }}</div>
        <div v-if="vacancy.pcd" class="nxp-featured-tag nxp-featured-tag-pcd">Para PCD</div>
        <!-- <div class="nxp-featured-tag nxp-affirmative">Vaga afirmativa</div> -->
      </div>

      <div class="w-full flex flex-col gap-2 mb-4">
        <div class="w-full flex flex-row gap-2 items-center nxp-created-at">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M8.43335 7.56394V4.43311C8.43335 4.31033 8.39213 4.20738 8.30968 4.12427C8.22724 4.04127 8.12513 3.99977 8.00335 3.99977C7.88146 3.99977 7.77824 4.04127 7.69368 4.12427C7.60902 4.20738 7.56668 4.31033 7.56668 4.43311V7.71777C7.56668 7.79622 7.58124 7.86666 7.61035 7.92911C7.63935 7.99155 7.67952 8.04844 7.73085 8.09977L10.0448 10.4139C10.1388 10.5079 10.2418 10.5532 10.3538 10.5498C10.4658 10.5463 10.5701 10.4963 10.6667 10.3998C10.7632 10.3032 10.8115 10.2 10.8115 10.0901C10.8115 9.98033 10.7613 9.87577 10.661 9.77644L8.43335 7.56394ZM8.00118 14.0664C7.16552 14.0664 6.37996 13.9085 5.64452 13.5928C4.90918 13.277 4.26479 12.8425 3.71135 12.2893C3.1579 11.736 2.72318 11.0911 2.40718 10.3544C2.09129 9.61788 1.93335 8.83083 1.93335 7.99327C1.93335 7.15572 2.09124 6.36822 2.40702 5.63077C2.72279 4.89333 3.15729 4.25066 3.71052 3.70277C4.26374 3.15488 4.90868 2.72294 5.64535 2.40694C6.38191 2.09105 7.16896 1.93311 8.00652 1.93311C8.84407 1.93311 9.63157 2.09233 10.369 2.41077C11.1066 2.72922 11.7481 3.16138 12.2937 3.70727C12.8392 4.25316 13.2711 4.89511 13.5893 5.63311C13.9076 6.37111 14.0667 7.15961 14.0667 7.9986C14.0667 8.83427 13.9088 9.61983 13.593 10.3553C13.2772 11.0906 12.8455 11.735 12.2978 12.2884C11.7502 12.8419 11.1071 13.2766 10.3685 13.5926C9.62996 13.9085 8.84085 14.0664 8.00118 14.0664ZM8.00802 13.1998C9.44657 13.1998 10.6716 12.6914 11.683 11.6748C12.6943 10.6581 13.2 9.43044 13.2 7.99177C13.2 6.55322 12.6943 5.32822 11.683 4.31677C10.6716 3.30544 9.44657 2.79977 8.00802 2.79977C6.56935 2.79977 5.34168 3.30544 4.32502 4.31677C3.30835 5.32822 2.80002 6.55322 2.80002 7.99177C2.80002 9.43044 3.30835 10.6581 4.32502 11.6748C5.34168 12.6914 6.56935 13.1998 8.00802 13.1998Z"
              fill="#696969" />
          </svg>
          <p>Publicada em {{ vacancy_published_at }}</p>
        </div>

        <!-- <p class="nxp-until-date">Envie seu currículo até 05/12/2024</p> -->

      </div>

      <div class="w-full flex flex-col gap-2 mt-10">
        <div v-if="description.length > 0" v-html="description"></div>

        <div class="w-full nxp-list-vacancy-details" v-if="skills.length > 0">
          <b class="nxp-skill-vacancy-title">Habilidades</b>
          <ul v-for="(skill, index) in skills" :key="`skill-${index}`">
            <li>{{ skill }}</li>
          </ul>
        </div>

        <div class=" w-full nxp-list-vacancy-details" v-if="benefits.length > 0">
          <b class="nxp-skill-vacancy-title">Benefícios</b>
          <ul v-for="(benefit, index) in benefits" :key="`benefit-${index}`">
            <li>{{ benefit }}</li>
          </ul>
        </div>
      </div>


      <div class="w-full flex flex-col-reverse md:flex-row gap-2 my-10">
        <button type="button" class="nxp-btn-vacancy-detail-back" @click="$router.back()">Voltar</button>
        <button v-if="isOpen && !isForms" class="nxp-btn-vacancy-detail" :style="{ backgroundColor: color }"
          @click="popupActive = true">
          Candidatar-se
        </button>
        <button v-else-if="isOpen && isForms" class="nxp-btn-vacancy-detail" :style="{ backgroundColor: color }" @click="doApplication">
          Responder perguntas e candidatar-se
        </button>
        <button v-else-if="!isOpen && !alreadyAnswered" class="nxp-btn-vacancy-detail" :style="{ backgroundColor: color }" @click="doApplication">
          Responder perguntas
        </button>
      </div>

    </div>


    <vs-popup title="Candidatar-se" :active.sync="popupActive">
      <vs-row>
        <vs-col class="mb-8" vs-type="flex" vs-align="center" vs-justify="end" vs-w="12">
          <p>Deseja realmente se candidatar-se a vaga?</p>
        </vs-col>

        <vs-col class="px-0 flex-row-reverse" vs-type="flex" vs-align="center" vs-justify="end" vs-w="12">
          <vs-button class="mx-1" @click="doApplication" color="primary" type="filled">
            Candidatar-se
          </vs-button>
          <vs-button class="mx-1" @click="popupActive = false" color="dark" type="flat">
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>



  <!-- <div class="wrapper_vacancy">
    <div class="closeBtn_vacancy">
      <feather-icon icon="XIcon" @click="$router.back()" />
    </div>
    <div class="title_vacancy">
      <h1>Detalhes da vaga</h1>
    </div>
    <div class="content_vacancy">
      <div class="group_vacancy">
        <h1>{{ title }}</h1>
        {{ location }}
        <div
          v-if="
            vacancy_published_at.length > 0 || talent_applicated_at.length > 0
          "
        >
          <p>
            {{
              `${
                isOpen
                  ? `Vaga aberta em  ${vacancy_published_at}`
                  : `Candidatura realizada no dia ${talent_applicated_at}`
              }`
            }}
          </p>
        </div>
      </div>
      <div class="group_vacancy">
        <div class=" w-full" v-if="description.length > 0">
          <b class="mb-2">Descrição da vaga</b>
          <div class="mb-1" v-html="description"></div>
        </div>
      </div>
      <div class="group_vacancy">
        <div class=" w-full" v-if="skills.length > 0">
          <b class="my-2">Conhecimento e Habilidades necessárias</b>
          <ul v-for="(skill, index) in skills" :key="`skill-${index}`">
            <div class="flex items-center">
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="h-4 w-4 text-primary"
                class="m-1"
              />
              <li>{{ skill }}</li>
            </div>
          </ul>
        </div>
      </div>
      <div class="group_vacancy">
        <div class=" w-full" v-if="benefits.length > 0">
          <b class="my-2">Benefícios</b>
          <ul v-for="(benefit, index) in benefits" :key="`benefit-${index}`">
            <div class="flex items-center">
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="h-4 w-4 text-primary"
                class="m-1"
              />
              <li>{{ benefit }}</li>
            </div>
          </ul>
        </div>
      </div>
      <div class="group_vacancy">
        <div class=" w-full" v-if="remuneration.length > 0">
          <b class="my-2">Faixa Salarial</b>
          <div class="flex items-center">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="h-4 w-4 text-primary"
              class="m-1"
            />
            {{ remuneration }}
          </div>
        </div>
      </div>
      <div class="group_vacancy">
        <div class="w-full" v-if="showLocation">
          <b class="my-2">Local</b>
          <div class="flex items-center">
            {{ location }}
          </div>
        </div>
      </div>
      <div v-if="isOpen" class="group_vacancy">
        <button
          v-if="!isForms"
          class="button_vacancy"
          :style="{ backgroundColor: color }"
          @click="popupActive = true"
        >
          Candidatar-se
        </button>
        <button
          v-else
          class="button_vacancy"
          :style="{ backgroundColor: color }"
          @click="doApplication"
        >
          Candidatar-se
        </button>
      </div>
    </div>
   
  </div> -->
</template>

<script>
import Axios from 'axios';
import { get } from 'lodash';

export default {
  props: ["vacancy", "isOpen", "isSimilar"],
  data: () => ({
    popupActive: false,
    isForms: false,
    step_id: "",
    alreadyAnswered: true,
  }),
  computed: {
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },

    formattedRemuneration() {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(this.vacancy.remuneration)
    },

    title() {
      return this.vacancy !== undefined && this.vacancy.hasOwnProperty("title")
        ? this.vacancy.title
        : "";
    },

    description() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("description")
        ? this.vacancy.description
        : "";
    },

    vacancy_published_at() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("published_at")
        ? this.vacancy.published_at
        : "";
    },

    talent_applicated_at() {
      return this.vacancy != undefined &&
        this.vacancy.hasOwnProperty("applications") &&
        this.vacancy.applications.length > 0
        ? new Date(this.vacancy.applications[0].created_at).toLocaleString(
          "pt-BR"
        )
        : "";
    },

    skills() {
      return this.vacancy != undefined &&
        this.vacancy.skills != undefined &&
        this.vacancy.hasOwnProperty("skills") &&
        this.vacancy.skills.length > 0
        ? this.vacancy.skills.split(",")
        : 0;
    },

    benefits() {
      return this.vacancy != undefined &&
        this.vacancy.benefits != undefined &&
        this.vacancy.hasOwnProperty("benefits") &&
        this.vacancy.benefits.length > 0
        ? this.vacancy.benefits.split(",")
        : 0;
    },

    remuneration() {
      if (
        this.vacancy != undefined &&
        this.vacancy.show_remuneration === 1 &&
        this.vacancy.fixed_remuneration === 1 &&
        this.vacancy.remuneration != undefined
      ) {
        return `R$: ${this.vacancy.remuneration}`;
      } else if (
        this.vacancy != undefined &&
        this.vacancy.remuneration_from != null &&
        this.vacancy.remuneration_to != null &&
        this.vacancy.show_remuneration === 1
      ) {
        return `De R$: ${this.vacancy.remuneration_from} até R$: ${this.vacancy.remuneration_to}`;
      }
      return "";
    },

    showLocation() {
      return (
        this.vacancy &&
        this.vacancy.show_location &&
        this.vacancy.show_location == 1
      );
    },

    location() {
      if (
        this.vacancy != undefined &&
        this.vacancy.location != null &&
        this.vacancy.show_location !== 0
      ) {
        if (this.vacancy.remote === 1) return "Remoto";
        else return this.vacancy.location;
      } else {
        return "Local Não Divulgado";
      }
    }
  },
  methods: {
    handleRedirectToApplicationProcess() {
      const { params } = this.$router.history.current;

      this.$router.push({
        name: "application-process",
        params: {
          ...params,
          step_id: this.step_id,
          vacancy_id: this.vacancy.id,
          company_label: this.isSimilar
            ? this.vacancy.company.label
            : this.$router.history.current.params.company_label
        }
      });
    },
    async doApplication() {
      try {
        this.popupActive = false;

        if (!this.isOpen && this.isForms && !this.alreadyAnswered) {
          this.handleRedirectToApplicationProcess();
          return;
        }
        this.$vs.loading();

        const company_label = this.isSimilar
          ? this.vacancy.company.label
          : this.$router.history.current.params.company_label;

        const body = {
          vacancy_id: this.vacancy.id,
          company_id: this.isSimilar ? this.vacancy.company.id : this.vacancy.company_id,
          manager_id: this.isSimilar ? this.vacancy.author.id : this.vacancy.manager_id,
        };

        if (this.isSimilar) {
          body.channel = "similar-vacancy-ai"
        }

        const response = await this.$http.post(
          `/api/v1/talent/${company_label}/user/applications`,
          body
        );

        this.$vs.loading.close();
        if (response.status == 200 && response.data.created) {
          if (this.isForms) {
            this.handleRedirectToApplicationProcess();
          } else {
            const { params } = this.$router.history.current;
            this.$router.push({
              name: "dashboard-vacancy",
              params,
              query: {
                success: true,
              }
            });
          }
          if (this.isSimilar) {
            window.woopra.track('similar-apply-click', {
              vacancy_id: this.vacancy.id,
              company_id: this.vacancy.company_id,
              manager_id: this.vacancy.manager_id
            });
          } else {
            window.woopra.track('company-vacancy-apply-click', {
              vacancy_id: this.vacancy.id,
              company_id: this.vacancy.company_id,
              manager_id: this.vacancy.manager_id
            });
          }
        }
      } catch (error) {
        this.popupActive = false;
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao se candidatar-se",
          text:
            "Você já se candidatou" ||
            "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }
    },
    async fetchForms() {
      try {
        const response = await this.$http.get(
          `/api/v1/questions/steps/vacancies/${this.vacancy.id}/exists`
        );

        this.isForms = response.data.data.step_id ? true : false;
        this.step_id = response.data.data.step_id;
        this.getAlreadyAnswered(response.data.data.step_id);
      } catch (error) {
        this.isForms = false;
      }
    },
    async getAlreadyAnswered(step_id) {
      try {
        const token = this.$store.getters["auth/token"];
        const baseURL = process.env.VUE_APP_CURRICULUM_SERVICE;
        const url = `/api/v1/questions/steps/vacancies/${this.vacancy.id}/${step_id}`;
        const config = {
          baseURL,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        };
        const response = await Axios.get(url, config);

        const { forms = [] } = response.data.data;
        if (forms.length > 0) {
          this.alreadyAnswered = false;
        }
      } catch (error) {
        if ([304, 404, 409].includes(get(error, "response.status", null))) {
          this.alreadyAnswered = true;
        }
      }
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.fetchForms();
  }
};
</script>

<style lang="scss" scoped>
.wrapper_vacancy {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 16px;
  background: #fff;

  @media screen and (min-width: 768px) {
    padding: 36px;
  }
}

.closeBtn_vacancy {
  display: flex;
  justify-content: flex-end;
}

.title_vacancy {
  display: flex;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
}

.content_vacancy {
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
}

.group_vacancy {
  width: 100%;
  margin: 16px auto;

  @media only screen and (min-width: 1020px) {
    width: 70%;
  }
}

.button_vacancy {
  width: 100%;
  display: flex;
  padding: 1rem;
  color: white;
  font-size: 1.25rem;
  border: 0;
  border-radius: 5px;
  justify-content: center;
  background-color: #1551b1;
}
</style>


<style lang="scss">
.nxp-vacancy-detail-close-btn {
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0px;
  cursor: pointer;
  border: none;
  background-color: transparent;
}

.nxp-vacancy-card-location {
  color: #4F4F4F;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.nxp-featured-tag {
  display: flex;
  padding: 4px 8px;
  gap: 8px;
  border-radius: 4px;
  border: 0.5px solid #A8A8A8;
  background: #FFF;
  color: #333;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-items: center;
}

.nxp-featured-tag-pcd {
  background: #C1F0F0;
  border: 0.5px solid #C1F0F0;

}

.nxp-affirmative {
  background: #D5CEFC;
  border: 0.5px solid #D5CEFC;
}

.nxp-created-at {
  color: #696969;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.nxp-until-date {
  color: #4F4F4F;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.nxp-skill-vacancy-title {
  color: #333;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 8px;

}

.nxp-list-vacancy-details ul {
  margin-left: 24px;
  list-style-type: disc !important;
}

.nxp-list-vacancy-details ul li {
  color: #4F4F4F;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.nxp-btn-vacancy-detail {
  display: flex;
  width: 100%;
  height: 48px;
  padding: 8px 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #309E3A;
  color: #FFF;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  cursor: pointer;
  margin-left: auto;
  transition: all ease 0.3s;
}

.nxp-btn-vacancy-detail:hover {
  filter: brightness(0.9);
}

.nxp-btn-vacancy-detail-back {
  display: flex;
  width: 100%;
  height: 48px;
  padding: 8px 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 0.5px solid #A8A8A8;
  background: #FFF;
  color: #4F4F4F;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  margin-left: auto;
  transition: all ease 0.3s;
}

.nxp-btn-vacancy-detail-back:hover {
  filter: brightness(0.9);
}
</style>